import { skipToken, useQuery } from '@tanstack/react-query';
import { IntegrationInstancesAPI } from '@/lib/api/work-integrations/instances';
import { workIntegrationsQueryKeys } from '@/lib/query-keys/work-integrations';
import { useGetIntegrationInstances } from './useIntegrationInstances';

export const useInstanceFieldMappingsQuery = ({
  cloudId,
  projectId,
}: {
  cloudId?: string;
  projectId?: string;
}) => {
  const { data: instances = [] } = useGetIntegrationInstances('JIRA', {
    enabled: !!cloudId,
  });

  const numericInstanceId = instances.find((inst) => inst.instanceId === cloudId)?.id;

  return useQuery({
    queryKey: workIntegrationsQueryKeys.instanceFieldMappings({ numericInstanceId, projectId }),
    queryFn: numericInstanceId
      ? () => IntegrationInstancesAPI.getInstanceFieldMappings(numericInstanceId, projectId)
      : skipToken,
    // Mappings are created in a separate tab's cache, which can't invalidate this one.
    refetchOnWindowFocus: true,
  });
};
